import { create } from 'zustand';

export type FinanceNotificationKind =
  | 'deposit.created'
  | 'deposit.updated'
  | 'withdraw.created'
  | 'withdraw.updated'
  | 'bank_account.created'
  | 'bank_account.updated';

export interface FinanceNotification {
  kind: FinanceNotificationKind;
  id?: string;
  status?: string;
  agentId?: string;
  memberId?: string;
  amount?: string;
  username?: string;
  accountNumber?: string;
  receivedAt: number;
}

interface NotificationsState {
  events: FinanceNotification[];
  unreadCount: number;
  add: (n: FinanceNotification) => void;
  markAllRead: () => void;
  clear: () => void;
}

const MAX_EVENTS = 50;

export const useNotificationsStore = create<NotificationsState>((set) => ({
  events: [],
  unreadCount: 0,
  add: (n) =>
    set((s) => ({
      events: [n, ...s.events].slice(0, MAX_EVENTS),
      unreadCount: s.unreadCount + 1,
    })),
  markAllRead: () => set({ unreadCount: 0 }),
  clear: () => set({ events: [], unreadCount: 0 }),
}));
